export const useSmartSticky = (getCurrentAmplitude = () => 0, getOffset = () => 0) => {
  const transform = ref(0)
  const route = useRoute()

  if (process.client) {
    let previousWindowScroll = window.scrollY
    let isScrollingDown = false

    const resetHeader = () => {
      transform.value = 0
      previousWindowScroll = window.scrollY
    }

    const handleScroll = () => {
      const currentScroll = window.scrollY
      const scrollDifference = currentScroll - previousWindowScroll
      const headerHeight = getCurrentAmplitude()

      // Skip if no scroll difference (prevents unnecessary calculations)
      if (Math.abs(scrollDifference) < 1) {
        return
      }

      // Determine scroll direction
      isScrollingDown = scrollDifference > 0

      // At top of page, always show header
      if (currentScroll <= 0) {
        transform.value = 0
      }
      // Below offset threshold
      else if (currentScroll > getOffset()) {
        if (isScrollingDown) {
          // Scrolling down - hide header
          transform.value = Math.max(-headerHeight, transform.value - Math.abs(scrollDifference))
        } else {
          // Scrolling up - show header
          transform.value = Math.min(0, transform.value + Math.abs(scrollDifference))
        }
      }

      previousWindowScroll = currentScroll
    }

    // Reset header when route changes (navigation or language switch)
    watch(
      () => route.fullPath,
      () => {
        nextTick(() => {
          resetHeader()
        })
      },
    )

    onMounted(() => {
      resetHeader()
      window.addEventListener('scroll', handleScroll, { passive: true })
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })
  }

  return { transform }
}
